import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var PhyTherapy = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 3.106a3.989 3.989 0 0 0-3.981 3.996A3.989 3.989 0 0 0 22 11.1a3.989 3.989 0 0 0 3.981-3.997A3.989 3.989 0 0 0 22 3.106Zm-5.83 3.996c0-3.232 2.61-5.852 5.83-5.852s5.83 2.62 5.83 5.852c0 3.233-2.61 5.853-5.83 5.853s-5.83-2.62-5.83-5.853Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.424 0c.511 0 .925.415.925.928v5.407c0 5.353 4.32 9.689 9.651 9.689 5.332 0 9.651-4.336 9.651-9.689V.928c0-.513.414-.928.925-.928.51 0 .924.415.924.928v5.407c0 6.378-5.147 11.545-11.5 11.545S10.5 12.713 10.5 6.335V.928c0-.513.414-.928.924-.928ZM16.293 21.913c.51 0 .925.416.925.928v20.231a.926.926 0 0 1-.925.928.926.926 0 0 1-.924-.928v-20.23c0-.513.414-.929.924-.929ZM27.707 21.913c.51 0 .924.416.924.928v20.231a.926.926 0 0 1-.924.928.926.926 0 0 1-.925-.928v-20.23c0-.513.414-.929.925-.929ZM22 29.919c.51 0 .924.415.924.928v12.225A.926.926 0 0 1 22 44a.926.926 0 0 1-.924-.928V30.847c0-.513.413-.928.924-.928Z"
  }));
});
PhyTherapy.displayName = 'PhyTherapy';
PhyTherapy.defaultProps = {
  'aria-label': 'PhyTherapy'
};
export default PhyTherapy;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/PhyTherapy.js
// module id = 3064
// module chunks = 11